const SK = {
  company: [
    "spoločnosť s ručením obmedzeným (s.r.o.)",
    "jednoduchá spoločnosť na akcie",
    "nezisková organizácia (N.O.)"
  ],
  legalArrangement: [
    "komanditná spoločnos (k.s)",
    "spolek",
    "družstvo (cooperative)"
  ],
  soleProprietorship: [
    "živnostník"
  ]
};
export {
  SK as default
};
